import { ModalWindow } from '@cian/ui-kit/modal';
import { Locations16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './GeoSwitcher.css';

interface IGeoSwitcherProps {
  header: JSX.Element;
  body: JSX.Element;
  regionTitle: string;
  onOpen(): void;
}

export const GeoSwitcher: React.FC<IGeoSwitcherProps> = ({ header, body, regionTitle, onOpen }) => {
  const regionTitleRef = React.useRef(regionTitle);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const openModal = React.useCallback(() => {
    onOpen();
    setIsOpen(true);
  }, []);

  const closeModal = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <div className={styles['wrapper']}>
        <button onClick={openModal} className={styles['button']}>
          <Locations16 color="current_color" /> <span className={styles['text']}>{regionTitleRef.current}</span>
        </button>
      </div>
      <ModalWindow open={isOpen} onClose={closeModal} header={header} content={body} width={1179} size="M" fixed />
    </>
  );
};
